import styled from 'styled-components';
import { pageEntry } from '../constants/keyframes/fades';

const StyledRouteTransitions = styled.main`
	position: relative;
	min-height: 50vh;
	height: 100%;
	-webkit-backface-visibility: hidden;
	margin-top: 5rem;

	.fade-enter,
	.fade-enter-active,
	.fade-enter-done,
	.fade-exit,
	.fade-exit-active,
	.fade-exit-done {
		height: 100%;
		transform-style: preserve-3d;
	}

	.fade-enter {
		display: none;
	}

	.fade-enter-active {
		display: none;
	}

	.fade-enter-done {
		display: block;
		opacity: 0;
		animation: ${pageEntry} ${props => props.theme.routeTransitions.enterDuration}ms ease forwards;
	}

	.fade-exit {
		opacity: 1;
	}

	.fade-exit-active {
		opacity: 0;
		transition: all ${props => props.theme.routeTransitions.exitDuration}ms ease;
	}

	.fade-exit-done {
	}
`;

export default StyledRouteTransitions;
